import { Component, OnInit } from "@angular/core";
import { latitude, longitude } from "../../global/map-global";

declare let ol: any;

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
    map: any;

    ngOnInit(): void {
         this.initMap();
    }

    private initMap() {
        this.map = new ol.Map({
            target: 'map',
            layers: [
                new ol.layer.Tile({
                source: new ol.source.OSM()
                })
            ],
            view: new ol.View({
                center: ol.proj.fromLonLat([longitude, latitude]),
                zoom: 18
            })
        });

        this.addPoint(latitude, longitude);
    }

    private addPoint(lat: number, lng: number) {
        let vectorLayer = new ol.layer.Vector({
          source: new ol.source.Vector({
            features: [new ol.Feature({
              geometry: new ol.geom.Point(ol.proj.transform([lng, lat], 'EPSG:4326', 'EPSG:3857')),
            })]
          }),
          style: new ol.style.Style({
            image: new ol.style.Icon({
              anchor: [0.5, 0.5],
              anchorXUnits: "fraction",
              anchorYUnits: "fraction",
              src: "assets/img/marker-icon.png",
            })
          })
        });
        this.map.addLayer(vectorLayer);
    }
}